import { FC, useEffect, ReactElement, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../user/UserContext';
import { ChickenSpinner } from './Routes';
import PageNotFound from '../pages/PageNotFound/PageNotFound';

interface Props {
  component?: ReactElement;
  featureFlag?: boolean;
}

export const Page: FC<Props> = ({ component, featureFlag }) => {
  const location = useLocation();
  const userContext = useContext(UserContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (!component) {
    if (!userContext?.ldIdentified) return <ChickenSpinner />;
    return <>{<PageNotFound featureFlag={featureFlag} />}</>;
  }

  return component;
};
